/**
 * The FAQ's question set and ordering, in ONE place.
 *
 * This exists because the visible FAQ and the FAQPage JSON-LD used to be two
 * unrelated lists: FAQContent.tsx rendered 16 questions from
 * pageContent.faq.questions, while page.tsx fed the schema a hardcoded array of
 * 12 differently-worded ones. Nothing on screen contradicted the schema, so two
 * claims banned by docs/BRAND_ENTITY_KIT.md ("You track opens, replies…" and
 * "…emails consistently bounce") sat in machine-readable form for Google and
 * every AI crawler until an audit caught them.
 *
 * Both now derive from this file plus the English locale, so the schema cannot
 * assert anything the page does not show — the rule stated at
 * app/(routes)/free-vc-list/page.tsx.
 *
 * Not a client component: page.tsx is a server component and cannot import from
 * a 'use client' module without dragging it into the client bundle.
 */
export interface FAQCategory {
  key: string;
  translationKey: string;
  questions: string[];
}

export const FAQ_CATEGORIES: FAQCategory[] = [
  {
    key: 'gettingStarted',
    translationKey: 'pageContent.faq.categories.gettingStarted',
    questions: ['whatIsSendVC', 'howDoesItWork', 'howLongToStart', 'whatFileFormats'],
  },
  {
    key: 'pricingBilling',
    translationKey: 'pageContent.faq.categories.pricingBilling',
    questions: ['howMuchDoesItCost', 'canICancel', 'areThereCommissions', 'paymentMethods'],
  },
  {
    key: 'investorNetwork',
    translationKey: 'pageContent.faq.categories.investorNetwork',
    questions: ['howManyInvestors', 'whatInvestors', 'investorVerification', 'whichIndustries'],
  },
  {
    key: 'securityPrivacy',
    translationKey: 'pageContent.faq.categories.securityPrivacy',
    questions: ['isDataSecure', 'gdprCompliant', 'whoSeesMyDeck', 'canIDeleteData'],
  },
];

/** Flat, render-ordered list of every question key shown on /faq. */
export const FAQ_QUESTION_KEYS: string[] = FAQ_CATEGORIES.flatMap((c) => c.questions);
